import React, { useState } from 'react';
import ArrowIcon from '../../assets/common/ArrowIcon';
import './QuickConfigurationsAccordion.scss';

const QuickConfigurationsAccordion = ({ title, subtitle, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="quick-config-accordion-container">
      <div
        className="quick-config-accordion-header"
        onClick={handleToggle}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleToggle();
          }
        }}
      >
        <div className="quick-config-accordion-title-section">
          <span className="quick-config-accordion-title">{title}</span>
          {subtitle && <span className="quick-config-accordion-subtitle">{subtitle}</span>}
        </div>
        <div className="quick-config-accordion-arrow-container">
          <ArrowIcon
            className={`quick-config-accordion-arrow ${
              isOpen ? 'quick-config-accordion-arrow-open' : ''
            }`}
          />
        </div>
      </div>
      <div
        className={`quick-config-accordion-content ${
          isOpen ? 'quick-config-accordion-content-open' : ''
        }`}
      >
        <div className="quick-config-accordion-content-inner">{children}</div>
      </div>
    </div>
  );
};

export default QuickConfigurationsAccordion;
